import isEmptyArray from './isEmptyArray';
import { getUserPermissions } from './storage.service';

const isAllowedTo = (allowedPermissions: string[]) => {
  if (isEmptyArray(allowedPermissions)) {
    return true;
  }

  return getUserPermissions().some((permission: string) =>
    allowedPermissions.includes(permission)
  );
};

export default isAllowedTo;
